import {styled} from "@mui/material/styles";
import {DRAWER_HEADER_HEIGHT_LG, DRAWER_HEADER_HEIGHT_SM} from "./DrawerConstants.ts";

export const DrawerHeader = styled('div', {name: 'DrawerHeader'})(({theme}) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    padding: theme.spacing(0, 1.5),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,

    // Explicit definition, although theme.mixins.toolbar also contains this
    '@media (min-width: 600px)': {
        minHeight: DRAWER_HEADER_HEIGHT_LG,
    },
    minHeight: DRAWER_HEADER_HEIGHT_SM,
}));
